import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import './hiringOfferModal.css';
import useHire from '../../../hooks/hiring/useHire';
import useUpdateHiring from '../../../hooks/hiring/useUpdateHiring';

const HiringOffer = ({ 
  isOpen, 
  onClose, 
  conversationId, 
  employeeId, 
  conversationData, 
  otherUserInfo, 
  jobOfferId,
  onSuccess,
  // Update mode props
  isUpdateMode = false,
  hiringId = null,
  currentStartDate = null,
  currentEndDate = null
}) => {
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  
  // Initialize dates from current values if in update mode
  useEffect(() => {
    if (isUpdateMode && currentStartDate) {
      const start = new Date(currentStartDate);
      setStartDate(start.toISOString().split('T')[0]);
    }
    if (isUpdateMode && currentEndDate) {
      const end = new Date(currentEndDate);
      setEndDate(end.toISOString().split('T')[0]);
    }
  }, [isUpdateMode, currentStartDate, currentEndDate]);

  const {handleHire, isHiring, error: hireError} = useHire({
    conversationId,
    employeeId,
    conversationData,
    jobOfferId,
    startDate: startDate || null,
    endDate: endDate || null,
    otherUserInfo,
    onSuccess: (result) => {
      setSuccess(true);
      setTimeout(() => {
        setStartDate('');
        setEndDate('');
        setError(null);
        setSuccess(false);
        if (onSuccess) onSuccess(result);
        onClose();
      }, 1000);
    },
    onError: (errorMsg) => {
      setError(errorMsg);
    },
  });

  const {handleUpdate, isUpdating, error: updateError} = useUpdateHiring({
    hiringId: isUpdateMode ? hiringId : null,
    startDate: startDate || null,
    endDate: endDate || null,
    onSuccess: (result) => {
      setSuccess(true);
      setTimeout(() => {
        setStartDate('');
        setEndDate('');
        setError(null);
        setSuccess(false);
        if (onSuccess) onSuccess(result);
        onClose();
      }, 1000);
    },
    onError: (errorMsg) => {
      setError(errorMsg);
    },
  });
  
  // Update error when hireError or updateError changes
  useEffect(() => {
    if (hireError) {
      setError(hireError);
    }
    if (updateError) {
      setError(updateError);
    }
  }, [hireError, updateError]);
  
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!startDate || !endDate) {
      setError('Por favor elige la fecha de inicio y la de termino de tu contrato');
      return;
    }

    setError(null);
    if (isUpdateMode) {
      await handleUpdate();
    } else {
      await handleHire();
    }
  };

  const isLoading = isHiring || isUpdating;

  const handleClose = () => {
    if (!isLoading) {
      setStartDate('');
      setEndDate('');
      setError(null);
      setSuccess(false);
      onClose();
    }
  };


  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={handleClose}
      contentLabel="Hiring Offer Modal"
      className="hiring-offer-modal"
      overlayClassName="hiring-modal__overlay"
      ariaHideApp={false}
    >
      <div className="hiring-modal__container">
        <button
          className="hiring-modal__close-button"
          onClick={handleClose}
          disabled={isLoading}
          aria-label="Cerrar"
        >
          ×
        </button>

        <h2 className="hiring-modal__title">
          {isUpdateMode ? 'Actualizar oferta laboral' : 'Genera tu oferta laboral'}
        </h2>
        <p className="hiring-modal__description">
          {isUpdateMode 
            ? 'Actualiza la fecha de inicio y la de termino de tu contrato'
            : 'Elige la fecha de inicio y la de termino de tu contrato'}
        </p>

        <form onSubmit={handleSubmit} className="hiring-modal__form">
          <div className="hiring-modal__date-section">
            <label className="hiring-modal__label">Fecha de inicio *</label>
            <input 
              type="date" 
              value={startDate} 
              onChange={(e) => setStartDate(e.target.value)} 
              required
            />
          </div>
        
          <div className="hiring-modal__date-section">
            <label className="hiring-modal__label">Fecha de termino *</label>
            <input 
              type="date" 
              value={endDate} 
              onChange={(e) => setEndDate(e.target.value)} 
              required
            />
          </div>  
           

          {error && (
            <div className="hiring-modal__error">
              {error}
            </div>
          )}

          {success && (
            <div className="hiring-modal__success">
              ✅ {isUpdateMode 
                ? '¡Oferta de contratación actualizada exitosamente!'
                : '¡Oferta de contratación enviada exitosamente!'}
            </div>
          )}

          <div className="hiring-modal__actions">
            <button
              type="button"
              className="hiring-modal__cancel-button"
              onClick={handleClose}
              disabled={isLoading}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="hiring-modal__submit-button"
              disabled={isLoading}
            >
              {isLoading 
                ? (isUpdateMode ? 'Actualizando...' : 'Enviando...') 
                : (isUpdateMode ? 'Actualizar' : 'Aceptar')}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default HiringOffer;

